<h2 mat-dialog-title class="title" data-testid="terms-and-conditions-title">{{'login.terms_and_conditions'|translate}}</h2>
<div mat-dialog-content class="container">
  <div class="terms">
    @if(language == "fr-FR") {
    <p></p>
    <h2 id="">Conditions Générales de Vente (CGV)</h2>
    <h3 id="1.Introduction">1. Introduction</h3>
    <p>Ces CGV définissent les conditions sous lesquelles les produits et services sont vendus par CAD.42 à ses
      clients. L'achat de produits ou services implique l'acceptation intégrale de ces conditions par le client.</p>
    <p></p>
    <h3 id="2.GarantiedesProduits">2. Garantie des Produits</h3>
    <p></p>
    <h4 style="margin-left: 30.0px;" id="2.1GarantiedesBatteries">2.1 Garantie des
      Batteries</h4>
    <p style="margin-left: 30.0px;">Les batteries fournies avec ou pour les objets connectés de CAD.42 sont garanties
      contre les défauts de fabrication et de fonctionnement pour une période de un (1) an à compter de la date
      d'achat. Cette garantie couvre le remplacement ou la réparation des batteries défectueuses, à la discrétion de
      CAD.42.</p>
    <p style="margin-left: 30.0px;"></p>
    <h4 style="margin-left: 30.0px;" id="2.2GarantiedesObjetsConnectés">2.2 Garantie des
      Objets Connectés</h4>
    <p style="margin-left: 30.0px;">Les objets connectés vendus par CAD.42 bénéficient d'une garantie de deux (2) ans
      contre les défauts de fabrication et de fonctionnement à partir de la date d'achat. Cette garantie inclut la
      réparation ou le remplacement des produits défectueux, selon l'évaluation de CAD.42.</p>
    <p></p>
    <h3 id="3.LimitationsdelaGarantie">3. Limitations de la Garantie</h3>
    <p>La garantie ne couvre pas les dommages résultant d'une utilisation inappropriée, d'accidents, de modifications
      ou de réparations effectuées par des tiers non autorisés par CAD.42. Elle ne s'applique également pas en cas
      d'usure normale du produit.</p>
    <p></p>
    <h3 id="4.ProcéduredeGarantie">4. Procédure de Garantie</h3>
    <p>Pour bénéficier de la garantie, le client doit contacter le service client de CAD.42 et fournir une preuve
      d'achat ainsi qu'une description détaillée du problème rencontré. CAD.42 se réserve le droit de demander le
      retour du produit pour inspection.</p>
    <p></p>
    <h3 id="5.PaiementetLivraison">5. Paiement et Livraison</h3>
    <p>Les modalités de paiement et de livraison des produits sont spécifiées lors de la commande et doivent être
      respectées par le client.</p>
    <p></p>
    <h3 id="6.ModificationsdesCGV">6. Modifications des CGV</h3>
    <p>CAD.42 peut modifier ces CGV à tout moment, avec un préavis raisonnable donné aux clients.</p>
    <p></p>
    <h3 id="7.Contact">7. Contact</h3>
    <p>Pour toute question relative à ces CGV, veuillez contacter le service client de CAD.42. Veuillez contacter
      CAD.42 à l'adresse <a class="external-link" href="mailto:support&#64;cad42.com" rel="nofollow"
        class="link">support&#64;cad42.com</a>.</p>
    <p></p>
    <hr>

    <h2 class="titleConditions">Conditions
      Générales de Location (CGL)
    </h2>
    <h3 id="1.Introduction.1">1. Introduction</h3>
    <p>Les présentes Conditions Générales de Location régissent les termes et conditions selon lesquels les matériels
      et systèmes de CAD.42 sont loués à nos clients. En signant un contrat de location, le client accepte ces
      conditions.</p>
    <p></p>
    <h3 id="2.DuréedelaLocation">2. Durée de la Location</h3>
    <p>La durée de la location est spécifiée dans le contrat de location. Tout dépassement, à partir d’une journée,
      donnera lieu à facturation de 30 jours supplémentaires.</p>
    <p></p>
    <h3 id="3.CoûtdesRéparations">3. Coût des Réparations</h3>
    <p></p>
    <h4 style="margin-left: 30.0px;" id="3.1ÉvaluationdesRéparations">3.1 Évaluation des
      Réparations</h4>
    <p style="margin-left: 30.0px;">Tout dommage survenant au matériel pendant la période de location sera évalué par
      CAD.42. Le coût des réparations nécessaires sera facturé au client selon le tarif en vigueur déterminé par
      CAD.42.</p>
    <p></p>
    <h4 style="margin-left: 30.0px;" id="3.2ResponsabilitéduLocataire">3.2 Responsabilité
      du Locataire</h4>
    <p style="margin-left: 30.0px;">Le locataire est responsable de l'utilisation adéquate du matériel conformément
      aux instructions fournies par CAD.42. Tout dommage résultant d'une mauvaise utilisation sera à la charge du
      locataire.</p>
    <p></p>
    <h3 id="4.RestitutionduMatériel">4. Restitution du Matériel</h3>
    <p>Le matériel doit être restitué à CAD.42 dans les cinq (5) jours suivant la fin de la période de location. En
      cas de retard dans la restitution, un nouveau mois de location sera automatiquement facturé au locataire.</p>
    <p></p>
    <p>En cas de non restitution du matériel, les éléments manquants seront facturés par CAD.42.</p>
    <p></p>
    <h3 id="5.Paiement">5. Paiement</h3>
    <p>Le paiement de la location, ainsi que des coûts additionnels relatifs aux réparations ou au retard de
      restitution, doit être effectué conformément aux termes spécifiés dans le contrat de location ou bon de
      commande.</p>
    <p></p>
    <h3 id="6.ModificationsdesCGL">6. Modifications des CGL</h3>
    <p>CAD.42 se réserve le droit de modifier ces CGL à tout moment. Les locataires seront informés de toute
      modification significative.</p>
    <p></p>
    <h3 id="7.Contact.1">7. Contact</h3>
    <p>Pour toute question ou besoin de clarification concernant ces CGL, les clients sont invités à contacter CAD.42.
      Veuillez contacter CAD.42 à l'adresse <a class="external-link" href="mailto:support&#64;cad42.com" rel="nofollow"
        class="link">support&#64;cad42.com</a>.</p>
    <p></p>
    <hr>

    <h2 class="titleConditions" id="ConditionsGénéralesd&#39;Utilisation(CGU)">Conditions
      Générales d'Utilisation
      (CGU)</h2>
    <h3 id="1.Introduction.2">1. Introduction</h3>
    <p>Les présentes Conditions Générales d'Utilisation régissent l'accès et l'utilisation des produits et services
      fournis par CAD.42, y compris l'utilisation des objets connectés et des applications associées. En utilisant les
      produits et services de CAD.42, vous acceptez de vous conformer à ces CGU.</p>
    <p></p>
    <h3 id="2.UtilisationdesServices">2. Utilisation des Services</h3>
    <p>Les services et produits de CAD.42 sont destinés à une utilisation conforme à leur destination prévue. Les
      utilisateurs doivent respecter toutes les instructions fournies, notamment en ce qui concerne la sécurité et la
      maintenance des produits.</p>
    <p></p>
    <h3 id="3.PropriétéIntellectuelle">3. Propriété Intellectuelle</h3>
    <p>Tous les contenus inclus ou accessibles via les produits et services de CAD.42, tels que les textes,
      graphiques, logos, et interfaces utilisateur, sont protégés par le droit d'auteur et sont la propriété exclusive
      de CAD.42.</p>
    <p></p>
    <h3 id="4.PropriétéetUtilisationdesDonnées">4. Propriété et Utilisation des Données
    </h3>
    <p></p>
    <h4 style="margin-left: 30.0px;" id="4.1PropriétédesDonnées">4.1 Propriété des Données
    </h4>
    <p style="margin-left: 30.0px;">Les données générées, collectées ou transmises par les objets connectés de CAD.42
      appartiennent exclusivement aux clients.</p>
    <p style="margin-left: 30.0px;"></p>
    <h4 style="margin-left: 30.0px;" id="4.2Consentementàl&#39;UtilisationdesDonnées">4.2
      Consentement à l'Utilisation des Données</h4>
    <p style="margin-left: 30.0px;">En utilisant nos services, vous autorisez CAD.42 à utiliser ces données pour la
      recherche et le développement, afin d'améliorer nos produits et services.</p>
    <p style="margin-left: 30.0px;"></p>
    <h4 style="margin-left: 30.0px;" id="4.3ProtectiondelaConfidentialité">4.3 Protection
      de la Confidentialité</h4>
    <p style="margin-left: 30.0px;">CAD.42 garantit la confidentialité des données collectées, qui seront traitées de
      manière anonyme pour toute activité de R&amp;D.</p>
    <p style="margin-left: 30.0px;"></p>
    <h4 style="margin-left: 30.0px;" id="4.4DroitdeRévocationetContrôledesDonnées">4.4
      Droit de Révocation et Contrôle des Données</h4>
    <p style="margin-left: 30.0px;">Les clients peuvent révoquer leur consentement à l'utilisation des données et
      exercer leur droit d'accès, de correction ou de suppression de leurs données personnelles.</p>
    <p></p>
    <h3 id="5.Sécurité">5. Sécurité</h3>
    <p>Les utilisateurs doivent suivre strictement toutes les instructions concernant la charge, le stockage, et
      l'utilisation des batteries au lithium pour prévenir tout risque.</p>
    <p></p>
    <p>Les systèmes anticollisions de CAD.42 sont conçus pour assister les utilisateurs dans la prévention des
      accidents. Ils ne doivent pas être considérés comme des substituts aux systèmes de sécurité machine ou à la
      vigilance du conducteur.</p>
    <p></p>
    <h3 id="6.ModificationsdesCGU">6. Modifications des CGU</h3>
    <p>CAD.42 se réserve le droit de modifier ces CGU à tout moment. Les utilisateurs seront informés de toute
      modification significative.</p>
    <p></p>
    <h3 id="7.Responsabilité">7. Responsabilité</h3>
    <p>CAD.42 n'est pas responsable des dommages résultant d'une mauvaise utilisation des produits, y compris le
      non-respect des instructions de sécurité pour les batteries au lithium.</p>
    <p></p>
    <h3 id="8.LimitationdeResponsabilité">8. Limitation de Responsabilité</h3>
    <p></p>
    <h4 style="margin-left: 30.0px;" id="8.1Non-responsabilitépourPannes">8.1
      Non-responsabilité pour Pannes</h4>
    <p style="margin-left: 30.0px;">CAD.42 ne peut être tenu responsable des accidents ou dommages causés par une
      défaillance des objets connectés ou des services associés. L'utilisateur assume la pleine responsabilité de leur
      utilisation.</p>
    <p style="margin-left: 30.0px;"></p>
    <h4 style="margin-left: 30.0px;" id="8.2RéglementationdeProtectiondesDonnées">8.2
      Réglementation de Protection des Données</h4>
    <p style="margin-left: 30.0px;">Le client est responsable du respect des lois applicables à la protection des
      données personnelles résultant de l'utilisation des produits CAD.42.</p>
    <p></p>
    <h3 id="9.Contact">9. Contact</h3>
    <p>Pour toute question ou demande concernant ces CGU, veuillez contacter CAD.42 à l'adresse <a class="external-link"
        href="mailto:support&#64;cad42.com" rel="nofollow" class="link">support&#64;cad42.com</a>.</p>

    }
    @if(language == "en-US") {
    <!----English-->
    <a href="https://cad42.atlassian.net/wiki/x/BYA1Jw" target="_blank" class="link">Link to general terms and
      conditions</a>

    <p></p>
    <h2 id="TermsandConditionsofCAD.42-TermsandConditionsofSale(T&amp;CS)">Terms and Conditions of Sale (T&amp;CS)
    </h2>
    <h3 id="TermsandConditionsofCAD.42-1.Introduction">1. Introduction</h3>
    <p>These T&amp;CS define the terms under which products and services are sold by CAD.42 to its customers. The
      purchase of products or services implies the full acceptance of these conditions by the customer.</p>
    <h3 id="TermsandConditionsofCAD.42-2.ProductWarranty">2. Product Warranty</h3>
    <h4 id="TermsandConditionsofCAD.42-2.1BatteryWarranty">2.1 Battery Warranty</h4>
    <p>Batteries supplied with or for CAD.42's connected objects are guaranteed against manufacturing defects and
      malfunctions for a period of one (1) year from the date of purchase. This warranty covers the replacement or
      repair of defective batteries, at CAD.42's discretion.</p>
    <h4 id="TermsandConditionsofCAD.42-2.2ConnectedObjectsWarranty">2.2 Connected Objects Warranty</h4>
    <p>Connected objects sold by CAD.42 are covered by a two (2) year warranty against manufacturing defects and
      malfunctions from the date of purchase. This warranty includes the repair or replacement of defective products,
      as assessed by CAD.42.</p>
    <h3 id="TermsandConditionsofCAD.42-3.WarrantyLimitations">3. Warranty Limitations</h3>
    <p>The warranty does not cover damages resulting from improper use, accidents, modifications, or repairs carried
      out by third parties not authorized by CAD.42. It also does not apply in cases of normal product wear and tear.
    </p>
    <h3 id="TermsandConditionsofCAD.42-4.WarrantyProcedure">4. Warranty Procedure</h3>
    <p>To benefit from the warranty, the customer must contact CAD.42's customer service and provide proof of purchase
      as well as a detailed description of the encountered issue. CAD.42 reserves the right to request the return of
      the product for inspection.</p>
    <h3 id="TermsandConditionsofCAD.42-5.PaymentandDelivery">5. Payment and Delivery</h3>
    <p>Payment and delivery terms for products are specified during the order and must be adhered to by the customer.
    </p>
    <h3 id="TermsandConditionsofCAD.42-6.ChangestoT&amp;CS">6. Changes to T&amp;CS</h3>
    <p>CAD.42 may modify these T&amp;CS at any time, with reasonable notice given to customers.</p>
    <h3 id="TermsandConditionsofCAD.42-7.Contact">7. Contact</h3>
    <p>For any questions regarding these T&amp;CS, please contact CAD.42's customer service at <a class="external-link"
        href="mailto:support&#64;cad42.com" rel="nofollow" class="link">support&#64;cad42.com</a>.</p>
    <hr>

    <h2 id="TermsandConditionsofCAD.42-TermsandConditionsofRental(T&amp;CR)">Terms and Conditions of Rental (T&amp;CR)
    </h2>
    <h3 id="TermsandConditionsofCAD.42-1.Introduction.1">1. Introduction</h3>
    <p>These Rental Terms and Conditions govern the terms under which CAD.42's equipment and systems are leased to our
      customers. By signing a rental agreement, the customer agrees to these conditions.</p>
    <h3 id="TermsandConditionsofCAD.42-2.RentalDuration">2. Rental Duration</h3>
    <p>The rental duration is specified in the rental agreement. Any extension, starting from one day, will result in
      billing for an additional 30 days.</p>
    <h3 id="TermsandConditionsofCAD.42-3.RepairCosts">3. Repair Costs</h3>
    <h4 id="TermsandConditionsofCAD.42-3.1RepairEvaluation">3.1 Repair Evaluation</h4>
    <p>Any damage occurring to the equipment during the rental period will be assessed by CAD.42. The cost of
      necessary repairs will be invoiced to the customer according to CAD.42's current rate.</p>
    <h4 id="TermsandConditionsofCAD.42-3.2Lessee&#39;sResponsibility">3.2 Lessee's Responsibility</h4>
    <p>The lessee is responsible for the proper use of the equipment in accordance with the instructions provided by
      CAD.42. Any damage resulting from misuse will be the responsibility of the lessee.</p>
    <h3 id="TermsandConditionsofCAD.42-4.EquipmentReturn">4. Equipment Return</h3>
    <p>The equipment must be returned to CAD.42 within five (5) days following the end of the rental period. In case
      of delay in return, an additional month of rental will be automatically billed to the lessee.</p>
    <p>In case of non-return of the equipment, missing items will be billed by CAD.42.</p>
    <h3 id="TermsandConditionsofCAD.42-5.Payment">5. Payment</h3>
    <p>Payment for the rental, as well as additional costs related to repairs or late return, must be made in
      accordance with the terms specified in the rental agreement or purchase order.</p>
    <h3 id="TermsandConditionsofCAD.42-6.ChangestoT&amp;CR">6. Changes to T&amp;CR</h3>
    <p>CAD.42 reserves the right to modify these T&amp;CR at any time. Lessees will be informed of any significant
      changes.</p>
    <h3 id="TermsandConditionsofCAD.42-7.Contact.1">7. Contact</h3>
    <p>For any questions or need for clarification regarding these T&amp;CR, customers are invited to contact CAD.42
      at <a class="external-link" href="mailto:support&#64;cad42.com" rel="nofollow"
        class="link">support&#64;cad42.com</a>.
    </p>
    <hr>

    <h2 id="TermsandConditionsofCAD.42-TermsandConditionsofUse(T&amp;CU)">Terms and Conditions of Use (T&amp;CU)</h2>
    <h3 id="TermsandConditionsofCAD.42-1.Introduction.2">1. Introduction</h3>
    <p>These Terms of Use govern access to and use of the products and services provided by CAD.42, including the use
      of connected objects and associated applications. By using CAD.42's products and services, you agree to comply
      with these T&amp;CU.</p>
    <h3 id="TermsandConditionsofCAD.42-2.ServiceUsage">2. Service Usage</h3>
    <p>CAD.42's services and products are intended for use in accordance with their intended purpose. Users must
      follow all provided instructions, particularly regarding product safety and maintenance.</p>
    <h3 id="TermsandConditionsofCAD.42-3.IntellectualProperty">3. Intellectual Property</h3>
    <p>All content included or accessible through CAD.42's products and services, such as texts, graphics, logos, and
      user interfaces, are protected by copyright and are the exclusive property of CAD.42.</p>
    <h3 id="TermsandConditionsofCAD.42-4.DataOwnershipandUsage">4. Data Ownership and Usage</h3>
    <h4 id="TermsandConditionsofCAD.42-4.1DataOwnership">4.1 Data Ownership</h4>
    <p>Data generated, collected, or transmitted by CAD.42's connected objects exclusively belong to the customers.
    </p>
    <h4 id="TermsandConditionsofCAD.42-4.2DataUsageConsent">4.2 Data Usage Consent</h4>
    <p>By using our services, you authorize CAD.42 to use this data for research and development purposes, to improve
      our products and services.</p>
    <h4 id="TermsandConditionsofCAD.42-4.3PrivacyProtection">4.3 Privacy Protection</h4>
    <p>CAD.42 guarantees the confidentiality of collected data, which will be processed anonymously for any R&amp;D
      activity.</p>
    <h4 id="TermsandConditionsofCAD.42-4.4DataRevocationRightandControl">4.4 Data Revocation Right and Control</h4>
    <p>Customers may revoke their consent to data usage and exercise their right to access, correct, or delete their
      personal data.</p>
    <h3 id="TermsandConditionsofCAD.42-5.Security">5. Security</h3>
    <p>Users must strictly follow all instructions regarding the charging, storage, and use of lithium batteries to
      prevent any risks.</p>
    <p>CAD.42's collision avoidance systems are designed to assist users in accident prevention. They should not be
      considered substitutes for machine safety systems or driver vigilance.</p>
    <h3 id="TermsandConditionsofCAD.42-6.ChangestoT&amp;CU">6. Changes to T&amp;CU</h3>
    <p>CAD.42 reserves the right to modify these T&amp;CU at any time. Users will be informed of any significant
      changes.</p>
    <h3 id="TermsandConditionsofCAD.42-7.Liability">7. Liability</h3>
    <p>CAD.42 is not liable for damages resulting from misuse of the products, including failure to comply with safety
      instructions for lithium batteries.</p>
    <h3 id="TermsandConditionsofCAD.42-8.LiabilityLimitation">8. Liability Limitation</h3>
    <h4 id="TermsandConditionsofCAD.42-8.1Non-LiabilityforFailures">8.1 Non-Liability for Failures</h4>
    <p>CAD.42 cannot be held responsible for accidents or damages caused by failures of connected objects or
      associated services. The user assumes full responsibility for their use.</p>
    <h4 id="TermsandConditionsofCAD.42-8.2DataProtectionRegulation">8.2 Data Protection Regulation</h4>
    <p>The customer is responsible for complying with applicable laws regarding personal data protection resulting
      from the use of CAD.42 products.</p>
    <h3 id="TermsandConditionsofCAD.42-9.Contact">9. Contact</h3>
    <p>For any questions or requests regarding these T&amp;CU, please contact CAD.42 at <a class="external-link"
        href="mailto:support&#64;cad42.com" rel="nofollow" class="link">support&#64;cad42.com</a>.</p>

    }
  </div>
</div>

<div mat-dialog-actions class="btn-actions">
  <lib-button color="outline" (click)="dismiss()" [text]="'signup.refuse_terms' | translate"></lib-button>
  <lib-button color="success" (click)="confirm()" [text]="'signup.accept_terms_and_conditions' | translate" data-testid="welcome-popup-validate-btn"></lib-button>
</div>